import { ArrowLeft, CheckCircle2, MapPin, Users, Award, Building2 } from "lucide-react";
import { Button } from "../components/ui/button";
import { useNavigate } from "react-router-dom";
import lpHomesImg from '../images/LpHomes.jpg'; 

const LaxmiPriyaRealEstate = () => {
  const navigate = useNavigate();

  return (
    <div className="lp-page">
      {/* Header */}
      <div className="lp-header">
        <div className="container">

            {/* Navigation */}
      <nav className="nav-bar" data-testid="main-navigation">
        <div className="nav-container">
          <div className="nav-logo" data-testid="company-logo">
            <img src={require('src/images/LaxmiPriyaLogo1.jpg')} alt="LaxmiPriya Group Logo" className="w-60 h-25" />
            <span className="logo-text"></span>
          </div>
        </div>
         </nav>
         
        </div>
         <Button
            variant="ghost"
            onClick={() => navigate("/")}
            className="back-btn"
            data-testid="back-to-home-btn"
          >
            <ArrowLeft className="mr-2 w-5 h-5" />
            Back to Home
          </Button>
      </div>

      {/* Hero Section */}
      <section className="lp-hero" data-testid="lp-hero-section">
        <div className="lp-hero-content">
          <div className="lp-hero-text">
            <div className="orange-accent"></div>
            <h1 className="lp-title" data-testid="lp-title">
              Core Ventures
            </h1>
            <div className="lp-subtitle-box">
              <h2 className="lp-subtitle">Laxmipriya Realestate</h2>
            </div>
            <p className="lp-description" data-testid="lp-description">
              Laxmipriya Realestate, a prominent division of Maruti Group, is committed to offering high-quality residential and commercial property solutions. It is the ideal choice for builders, landlords and homeowners seeking reliable, customer-centric real estate services.
            </p>
          </div>
          <div className="lp-hero-image">
            <div className="blue-circle"></div>
            <img 
              src="https://customer-assets.emergentagent.com/job_md-design-app/artifacts/zjqa8y6p_4.jpg"
              alt="Modern Building"
              className="building-image"
            />
          </div>
        </div>
      </section>

      {/* Plotting Business Section */}
      <section className="lp-plotting" data-testid="lp-plotting-section">
        <div className="lp-plotting-content">
          <div className="lp-plotting-image">
            <img 
              src="https://customer-assets.emergentagent.com/job_md-design-app/artifacts/cm9s9mqv_7.jpg"
              alt="Plotting Business"
            />
          </div>
          <div className="lp-plotting-text">
            <div className="orange-bar"></div>
            <h2 className="lp-section-title orange-text" data-testid="plotting-title">
              Plotting Projects:
            </h2>
            <p className="lp-section-description" data-testid="plotting-description">
              Currently, we are developing a substantial 30-acre plotting project in Nuapatna, serving a diverse client base with over 100 satisfied customers. This venture is known for its transparency, prime locations and exceptional service standards
            </p>
            <div className="location-markers">
              <div className="location-item">
                <MapPin className="w-5 h-5 text-orange-600" />
                <span>LP NITYAM NEST - Banamalipur</span>
              </div>
              <div className="location-item">
                <MapPin className="w-5 h-5 text-orange-600" />
                <span>LP SRISTIKA VALLEY - Nuapatana</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Residential Projects Section */}
      <section className="lp-residential" data-testid="lp-residential-section">
        <div className="lp-residential-content">
          <div className="lp-residential-image">
            <img 
              src={lpHomesImg}
              alt="Residential Projects"
            />
            <div className="orange-border-left"></div>
          </div>
          <div className="lp-residential-text">
            <h2 className="lp-section-title orange-text" data-testid="residential-title">
              Residential Projects:
            </h2>
            <p className="lp-section-description" data-testid="residential-description">
             Our upcoming residential development is a premium S+S+5 apartment project lacated at Belgachia, just 2km from Trishulia Chhak. This project will feature well designed 2BHK and 3BHK apartments, offering spacious layouts, quality construction and contemporary amenities. With this expansion, Laxmi Priya Real Estate continues to strengthen its footprint in both residential and commercial real estate, delivering projects that meet the evolving needs of modern homebuyers.
            </p>

            <div className="divider"></div>

            <h3 className="lp-subsection-title orange-text" data-testid="experience-title">
              Experience and Expertise
            </h3>
            <p className="lp-section-description" data-testid="experience-description">
              With over five years in the real estate sector, Laxmi Priya Real Estate brings seasoned expertise and a skilled team to every project, ensuring excellence in delivery and customer trust.
            </p>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="lp-stats" data-testid="lp-stats-section">
        <div className="container">
          <h2 className="section-title" data-testid="stats-title">Our Achievements</h2>
          <div className="lp-stats-grid">
            <div className="lp-stat-card" data-testid="stat-card-0">
              <Users className="stat-icon" />
              <div className="stat-value">100+</div>
              <div className="stat-label">Satisfied Customers</div>
            </div>
            <div className="lp-stat-card" data-testid="stat-card-1">
              <MapPin className="stat-icon" />
              <div className="stat-value">30</div>
              <div className="stat-label">Acres in Development</div>
            </div>
            <div className="lp-stat-card" data-testid="stat-card-2">
              <Building2 className="stat-icon" />
              <div className="stat-value">8</div>
              <div className="stat-label">Flat Apartment Completed</div>
            </div>
            <div className="lp-stat-card" data-testid="stat-card-3">
              <Award className="stat-icon" />
              <div className="stat-value">5+</div>
              <div className="stat-label">Years of Experience</div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Features Section */}
      <section className="lp-features" data-testid="lp-features-section">
        <div className="container">
          <h2 className="section-title" data-testid="features-title">Why Choose Laxmi Priya Real Estate?</h2>
          <div className="lp-features-grid">
            <div className="lp-feature-card" data-testid="feature-card-0">
              <CheckCircle2 className="w-8 h-8 text-orange-600" />
              <h3>Transparency</h3>
              <p>Known for transparent dealings and clear communication throughout the project lifecycle</p>
            </div>
            <div className="lp-feature-card" data-testid="feature-card-1">
              <CheckCircle2 className="w-8 h-8 text-orange-600" />
              <h3>Prime Locations</h3>
              <p>Strategic locations ensuring connectivity and access to essential amenities</p>
            </div>
            <div className="lp-feature-card" data-testid="feature-card-2">
              <CheckCircle2 className="w-8 h-8 text-orange-600" />
              <h3>Quality Construction</h3>
              <p>Commitment to high-quality construction standards and client satisfaction</p>
            </div>
            <div className="lp-feature-card" data-testid="feature-card-3">
              <CheckCircle2 className="w-8 h-8 text-orange-600" />
              <h3>Customer-Centric</h3>
              <p>Reliable, customer-focused services tailored to builders, landlords, and homeowners</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="lp-cta" data-testid="lp-cta-section">
        <div className="container">
          <div className="lp-cta-content">
            <h2 data-testid="cta-title">Ready to Invest in Your Future?</h2>
            <p data-testid="cta-description">Contact us today to learn more about our current and upcoming projects</p>
            <Button 
              size="lg" 
              className="cta-btn"
              onClick={() => navigate("/#contact")}
              data-testid="cta-contact-btn"
            >
              Get in Touch
            </Button>
          </div>
        </div>
      </section>

        {/* Footer */}
      <footer className="footer" data-testid="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <img src={require('src/images/LaxmiPriyaLogo1.jpg')} alt="LaxmiPriya Group Logo" className="w-90 h-40" />
              <span></span>
            </div>
            <p className="footer-text">
              Building sustainable futures since 1987. Committed to quality, innovation, and customer satisfaction.
            </p>
          </div>
          <div className="footer-bottom">
            <p>© 2025 Maruti Group. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LaxmiPriyaRealEstate;
